import { createContext, useContext } from 'react';

/**
 * The DOM root the widget is mounted into: a `ShadowRoot` when embedded, else
 * `document`. Query ids here, since `document.getElementById` cannot pierce it.
 */
export const WidgetRootContext = createContext<ShadowRoot | Document | null>(null);

/** Resolve the widget's DOM root, falling back to `document` without a provider. */
export function useWidgetRoot(): ShadowRoot | Document {
  return useContext(WidgetRootContext) ?? document;
}
